import * as React from 'react';
import {
    EnteredValueTextFieldProps,
    SelectableTextFieldProps,
    SelectableTextFieldState,
} from './SelectableTextField.types';
import { getEnteredValueTextFieldStyles } from './SelectableTextField.styles';
import { ITextField, TextField } from 'office-ui-fabric-react/lib/components/TextField';
import { KeyCodes } from 'office-ui-fabric-react/lib/Utilities';

const styles = require('./SelectableTextField.scss');
const classNames = require('classnames');

/**
 * This components shows some text to user and only when
 * they click on it it shows a text field so user can enter
 * new value.
 */
export class SelectableTextField extends React.Component<
    SelectableTextFieldProps,
    SelectableTextFieldState
> {
    constructor(props: SelectableTextFieldProps) {
        super(props);
        this.state = {
            isTextFieldShown: false,
        };
    }

    render() {
        const { className, placeholderText } = this.props;
        const shouldShowTextField = this.state.isTextFieldShown;

        return (
            <div className={classNames(styles.container, className)} onClick={this.onClick}>
                {shouldShowTextField ? (
                    <EnteredValueTextField
                        {...this.props}
                        onEntry={this.onEntry}
                        onDismiss={this.onDismiss}
                    />
                ) : (
                    <span>{placeholderText}</span>
                )}
            </div>
        );
    }

    public focus() {
        this.setTextFieldShown(true);
    }

    private onClick = () => {
        if (!this.state.isTextFieldShown) {
            this.setTextFieldShown(true);
        }
    };

    private onEntry = (value: string) => {
        if (value && value !== '') {
            // Trigger onEntry only if the user wrote something
            this.props.onEntry(value);
        }

        this.setTextFieldShown(false);
    };

    private onDismiss = () => {
        this.setTextFieldShown(false);
        this.props.onDismiss();
    };

    private setTextFieldShown(val: boolean) {
        this.setState(prevState => ({
            ...prevState,
            isTextFieldShown: val,
        }));
    }
}

/**
 * Component that renders a TextField that is focused when mounted,
 * and issues a callback with the current value when "Enter" is pressed.
 */
class EnteredValueTextField extends React.Component<EnteredValueTextFieldProps, {}> {
    private textField: ITextField;

    componentDidMount() {
        this.textField.focus();
        this.textField.select();
    }

    render() {
        return (
            <TextField
                styles={getEnteredValueTextFieldStyles}
                className={this.props.textFieldClassName}
                placeholder={this.props.placeholderTextFieldValue}
                onClick={this.onClick}
                onBlur={this.onBlur}
                onKeyDown={this.onKeyDown}
                componentRef={this.setTextFieldRef}
            />
        );
    }

    private setTextFieldRef = (input: ITextField) => {
        this.textField = input;
    };

    private onClick(evt: React.MouseEvent<unknown>) {
        evt.stopPropagation();
    }

    private onBlur = (evt: React.FocusEvent<HTMLElement>) => {
        if (!(evt.currentTarget as HTMLElement).contains(document.activeElement)) {
            this.props.onDismiss();
        }
    };

    private onKeyDown = (evt: React.KeyboardEvent<unknown>) => {
        // We stop propogation of the event if we are able to handle it
        switch (evt.which) {
            case KeyCodes.enter:
                this.props.onEntry(this.textField.value);
                evt.stopPropagation();
                break;
            case KeyCodes.escape:
                this.props.onDismiss();
                if (this.props.onUserPressEscape) {
                    this.props.onUserPressEscape();
                }
                evt.stopPropagation();
                break;
        }
    };
}
